import React from 'react';
import { Navigate } from 'react-router-dom';
import { useFeatureFlags } from '../contexts/FeatureFlagContext';

const VenueRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { venues, loading } = useFeatureFlags();

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundColor: '#181A1B',
        color: 'var(--text-primary)',
      }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '24px', marginBottom: '16px' }}>⚽</div>
          <div>Cargando...</div>
        </div>
      </div>
    );
  }

  if (!venues) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default VenueRoute;
